var map = {
	"./locale-en.json": "BTza"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2orj";


//////////////////
// WEBPACK FOOTER
// ./src/i18n ^\.\/locale\-.*\.json$
// module id = 2orj
// module chunks = 1